import * as Luxon from 'luxon'
import { getAllPosts } from '../../api/posts'
import { getPostBySlug } from '../../api/post/[slug]'
import Page from 'components/Page'
// import BlogSectionTitle from 'components/BlogSectionTitle'
import * as styles from '../blogIndex.module.css'
import BlogContent from 'components/BlogContent'
import BlogTableOfContents, { tocItem } from 'components/BlogTableOfContents'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Html from 'components/Html'
import Head from 'next/head'

type Props = {
  title: string,
  imagePath: string,
  imageAlt: string,
  date: string,
  subtitle: string,
  toc: tocItem[],
  content: string,
  description: string,
}

export default function BlogPost(props: Props) {
  const router = useRouter()
  const { slug } = router.query
  // console.log({ content: props.content })
  return <Page
    title={`Blog - ${props.title}`}
    width='blog'
    description={props.description}
  >
    <Head>
      <style type='text/css' media='screen' dangerouslySetInnerHTML={{ __html: `
        .blogImageRight {
          float: right;
          max-width: 50%;
          margin-left: 4%;
          margin-bottom: 4%;
        }
        .spacerPara {
          width: 100%;
          height: 8px;
        }
        .blogCallout {
          padding: 24px;
          background-color: #f7f7f7;
          border-radius: 8px;
        }
        .blogCallout h3:first-child {
          margin-top: 0 !important;
        }
      `}}>
      </style>
    </Head>
    <BlogContent>
      <article className={styles.postCard}>
        {props.imagePath &&
          <div className={styles.postThumbnail}>
            <img className={styles.thumbnail} src={`/static/images/blog/${props.imagePath}`} alt={props.imageAlt} />
          </div>
        }
        <header className={styles.postHeader}>
          <div className={styles.postMeta}>
            <time
              className={styles.published}
              dateTime={Luxon.DateTime.fromISO(props.date).toLocaleString(Luxon.DateTime.DATE_HUGE)}>
                { Luxon.DateTime.fromISO(props.date).toLocaleString(Luxon.DateTime.DATE_HUGE) }
            </time> on <Link href='/blog'><a>the blog</a></Link>
          </div>
          <h1 className={styles.postTitle}><Html>{props.title}</Html></h1>
          {props.subtitle &&
            <div className={styles.postSubtitle}>
              {props.subtitle}
            </div>
          }
        </header>
        <BlogTableOfContents basePath={`/blog/posts/${slug}`} toc={props.toc} />
        <div
          className={styles.postContent}
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      </article>
    </BlogContent>
  </Page>
}

export async function getStaticProps(context: any) {
  return {
    props: await getPostBySlug(context.params.slug)
  }
}

export async function getStaticPaths() {
  const posts = await getAllPosts()
  const paths = posts.map(post => ({
    params: { slug: post.slug }
  }))
  // const paths = [] as string[]
  return {
    paths,
    fallback: false
  }
}
